import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import { useCartContext } from "vino/context";
import { FormattedAmount } from "vino/core";
import { calculateSubtotal } from "utils";

const CartFooter = () => {
	const { cartLineItems } = useCartContext();
	const subtotal = calculateSubtotal(cartLineItems);
	return (
		<>
			<ListItem className="px-8">
				<div className="flex justify-between items-center w-full py-7">
					<span className="text-12 font-semibold">Subtotal</span>

					<FormattedAmount className="text-12 font-semibold" value={subtotal} />
				</div>
			</ListItem>
			<Divider component="li" />
		</>
	);
};

export default CartFooter;
